
export default function getRendomColor(colorArr,num) {
    let length = colorArr.length;
    let n = num%length;
    return colorArr[n];
}